import React from "react";
import { FiMaximize2, FiMinimize2, FiMinus, FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";

export default function WindowFrame({
  windowId,
  title,
  focusedWindow,
  flashWindow,
  maximizedWindow,
  minimizedWindows,
  onFocus,
  onClose,
  onToggleMinimize,
  onToggleMaximize,
  registerRef,
  className = "",
  showMinimize = true,
  showMaximize = true,
  children,
}) {
  const { t } = useTranslation("aiPortfolio");
  const isMaximized = maximizedWindow === windowId;
  const isMinimized = minimizedWindows.includes(windowId);
  const classes = `desktopWindow ${className} ${focusedWindow === windowId ? "focused" : ""} ${
    flashWindow === windowId ? "flash" : ""
  } ${isMaximized ? "maximized" : ""} ${isMinimized ? "minimized" : ""}`.trim();

  return (
    <article
      ref={(element) => registerRef(windowId, element)}
      className={classes}
      onMouseDown={() => onFocus(windowId)}
    >
      <div className="windowTop">
        <p>{title}</p>
        <div className="windowTopControls">
          {showMinimize && (
            <button
              type="button"
              aria-label={isMinimized ? t("windowActions.restore") : t("windowActions.minimize")}
              onClick={() => onToggleMinimize(windowId)}
            >
              <FiMinus />
            </button>
          )}
          {showMaximize && (
            <button
              type="button"
              aria-label={isMaximized ? t("windowActions.restore") : t("windowActions.maximize")}
              onClick={() => onToggleMaximize(windowId)}
            >
              {isMaximized ? <FiMinimize2 /> : <FiMaximize2 />}
            </button>
          )}
          <button type="button" aria-label={t("windowActions.close")} onClick={() => onClose(windowId)}>
            <FiX />
          </button>
        </div>
      </div>
      <div className="windowBody">{children}</div>
    </article>
  );
}
